// Full class strings, not built by interpolation. Tailwind only ships classes
// it can find literally in the source.
export const ZONE_STYLES = {
  interval: { pill: 'bg-red-50 text-red-700', dot: 'bg-red-600' },
  threshold: { pill: 'bg-amber-50 text-amber-700', dot: 'bg-amber-600' },
  steady: { pill: 'bg-sky-50 text-sky-700', dot: 'bg-sky-600' },
  easy: { pill: 'bg-emerald-50 text-emerald-700', dot: 'bg-emerald-600' },
  recovery: { pill: 'bg-slate-100 text-slate-600', dot: 'bg-slate-500' },
};
